import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { CreditCardBlockedIcon } from "@jti/brand-icons/credit-card-blocked";
import { EditIcon } from "@jti/brand-icons/edit";
import { NoiseAndSmokeIcon } from "@jti/brand-icons/noise-and-smoke";
import { PackageIcon } from "@jti/brand-icons/package";
import { PackageArrowIcon } from "@jti/brand-icons/package-arrow";
import { PackageCheckIcon } from "@jti/brand-icons/package-check";
import { PackageTimeIcon } from "@jti/brand-icons/package-time";
import { PlusFallingIcon } from "@jti/brand-icons/plus-falling";
import { ProfileDefaultIcon } from "@jti/brand-icons/profile-default";
import { UiCheckCircleIcon } from "@jti/brand-icons/ui-check-circle";
import { LinkBehaviour } from "../LinkBehaviour";
import styles from "./EcommerceReassuranceBanner.module.scss";
export const iconsNames = [
    "checkMarkWithRoundBorder",
    "cardWithLock",
    "package",
    "packageWithClock",
    "packageWithArrow",
    "packageWithCheckMark",
    "account",
    "edit",
    "noSmokeSmell",
    "falling",
];
const icons = {
    checkMarkWithRoundBorder: _jsx(UiCheckCircleIcon, {}),
    cardWithLock: _jsx(CreditCardBlockedIcon, {}),
    package: _jsx(PackageIcon, {}),
    packageWithClock: _jsx(PackageTimeIcon, {}),
    packageWithArrow: _jsx(PackageArrowIcon, {}),
    packageWithCheckMark: _jsx(PackageCheckIcon, {}),
    account: _jsx(ProfileDefaultIcon, {}),
    edit: _jsx(EditIcon, {}),
    noSmokeSmell: _jsx(NoiseAndSmokeIcon, {}),
    falling: _jsx(PlusFallingIcon, {}),
};
export const EcommerceReassuranceBanner = ({ items }) => {
    return (_jsx("ul", { className: styles.container, children: items.map(({ description, iconName, id, href }) => (_jsxs("li", { className: classNames(styles.item), children: [_jsx("span", { className: styles.iconWrapper, "data-testid": "ecommerceReassuranceBanner-icon", children: icons[iconName] }), _jsx("span", { className: styles.description, children: description }), href && _jsx(LinkBehaviour, { href: href, className: styles.link })] }, id))) }));
};
//# sourceMappingURL=EcommerceReassuranceBanner.js.map